import { loadCachedImage } from "#/game/cachedImage";
import { isImageReady } from "#/game/imageReady";

export type ExplosionKind = "land" | "air";

export interface ExplosionFrame {
  img: HTMLImageElement;
  sx: number;
  sy: number;
  sw: number;
  sh: number;
}

const EXPLOSION_COLS: Record<ExplosionKind, number> = {
  land: 9,
  air: 8,
};

function sheetUrl(kind: ExplosionKind): string {
  return `/fx/explosion-${kind}.png`;
}

function loadSheet(kind: ExplosionKind): HTMLImageElement {
  return loadCachedImage(sheetUrl(kind));
}

export function preloadExplosionSheets(): HTMLImageElement[] {
  return [loadSheet("land"), loadSheet("air")];
}

export function explosionFrameCount(kind: ExplosionKind): number {
  return EXPLOSION_COLS[kind];
}

export function getExplosionFrame({
  kind,
  frame,
}: {
  kind: ExplosionKind;
  frame: number;
}): ExplosionFrame | null {
  const img = loadSheet(kind);
  if (!isImageReady(img)) return null;
  const cols = EXPLOSION_COLS[kind];
  const index = Math.max(0, Math.min(cols - 1, frame));
  const sw = img.naturalWidth / cols;
  const sh = img.naturalHeight;
  return { img, sx: index * sw, sy: 0, sw, sh };
}
